import { render, staticRenderFns } from "./electricMachinery.vue?vue&type=template&id=5a20072e&scoped=true"
import script from "./electricMachinery.vue?vue&type=script&lang=js"
export * from "./electricMachinery.vue?vue&type=script&lang=js"
import style0 from "./electricMachinery.vue?vue&type=style&index=0&id=5a20072e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20072e",
  null
  
)

export default component.exports